export default __webpack_public_path__ + "static/color-analysis-result-winter-dc46625cd943b85000e94ff4b91b8231.jpg";